import { CalendarClock, CheckCircle2, CircleAlert, Clock3 } from "lucide-react";

const STATUS = {
  complete: { label: "Complete", Icon: CheckCircle2, className: "is-complete" },
  pending: { label: "Not started", Icon: Clock3, className: "is-pending" },
  overdue: { label: "Overdue", Icon: CircleAlert, className: "is-overdue" },
};

const detailFor = (source) => {
  if (source.status === "complete") return `${source.checked} of ${source.total} people · ${source.version || ""}`.trim();
  if (source.checked) return `${source.checked} of ${source.total} people checked so far`;
  if (source.key === "sam" && source.skipped) return "Skipped — SAM.gov API key not configured";
  return `0 of ${source.total} people`;
};

export const ScreeningStatusBoard = ({ status }) => {
  if (!status) return null;
  return (
    <div className="screening-status" data-testid="screening-status-board">
      <div className="screening-status-head">
        <b><CalendarClock size={14} /> {status.label} screening status</b>
        <span>Every source must be complete by {new Date(`${status.due_date}T12:00:00`).toLocaleDateString(undefined, { month: "long", day: "numeric" })}.</span>
      </div>
      <div className="screening-status-grid">
        {status.sources.map((source) => {
          const meta = STATUS[source.status] || STATUS.pending;
          return (
            <article key={source.key} className={`screening-status-tile ${meta.className}`} data-testid={`screening-status-${source.key}`}>
              <header>
                <span>{source.label}</span>
                <em data-testid={`screening-status-${source.key}-state`}><meta.Icon size={13} /> {meta.label}</em>
              </header>
              <p>{detailFor(source)}</p>
              <small>
                {source.matches ? `${source.matches} match(es) · ` : ""}
                {source.verify_license ? `${source.verify_license} license check(s) · ` : ""}
                {source.completed_at ? `Last checked ${new Date(source.completed_at).toLocaleDateString()}` : `Due ${source.due_date}`}
              </small>
            </article>
          );
        })}
      </div>
    </div>
  );
};
